// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

/* ──────────────────────────────────────────────
   Order Verify Page — ov-* BEM
   ────────────────────────────────────────────── */
.ov-page {
  padding: 20px 24px 40px;
  max-width: 1200px;
  margin: 0 auto;
}

/* ── Breadcrumb ── */
.ov-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6d6e71;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.ov-breadcrumb__link {
  color: rgb(105, 190, 40);
  text-decoration: none;
}
.ov-breadcrumb__link:hover {
  text-decoration: underline;
}
.ov-breadcrumb__sep {
  color: #bbb;
}
.ov-breadcrumb__current {
  color: #555;
  font-family: "Museo-regular";
}
.ov-breadcrumb__shop-link {
  margin-left: auto;
  color: rgb(105, 190, 40);
  text-decoration: none;
  font-size: 13px;
}
.ov-breadcrumb__shop-link:hover {
  text-decoration: underline;
}

/* ── Header ── */
.ov-header {
  margin-bottom: 24px;
}
.ov-header__title {
  font-family: "Museo-700";
  font-size: 22px;
  color: #6d6e71;
  margin: 0;
}
.ov-header__title i {
  color: rgb(105, 190, 40);
  margin-right: 6px;
}

/* ── Two-column layout ── */
.ov-layout {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 28px;
  align-items: start;
}
@media (max-width: 900px) {
  .ov-layout {
    grid-template-columns: 1fr;
  }
}
.ov-layout__main {
  min-width: 0;
}
@media (max-width: 900px) {
  .ov-layout__sidebar {
    order: -1;
  }
}

/* ── Card container ── */
.ov-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  margin-bottom: 24px;
  overflow: hidden;
}
.ov-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}
.ov-card__title {
  font-family: "Museo-regular";
  font-size: 15px;
  color: #6d6e71;
  margin: 0;
}
.ov-card__badge {
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 12px;
  font-family: "Museo-regular";
  padding: 2px 9px;
  border-radius: 12px;
}

/* ── Cart item row ── */
.ov-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}
.ov-item:last-child {
  border-bottom: none;
}
.ov-item__image {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ov-item__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ov-item__image--gift {
  background: #dbf4c9;
}
.ov-item__image--gift i {
  font-size: 26px;
  color: rgb(105, 190, 40);
}
.ov-item__body {
  flex: 1;
  min-width: 0;
}
.ov-item__name {
  font-family: "Museo-regular";
  font-size: 14px;
  color: #6d6e71;
  margin: 0 0 4px;
  cursor: pointer;
  text-decoration: none;
}
.ov-item__name:hover {
  color: rgb(105, 190, 40);
}
.ov-item__name--comp {
  cursor: pointer;
}
.ov-item__comp-badge {
  display: inline-block;
  font-size: 11px;
  font-family: "Museo-regular";
  background: #dbf4c9;
  color: rgb(105, 190, 40);
  padding: 1px 8px;
  border-radius: 10px;
  margin-left: 6px;
  vertical-align: middle;
}
.ov-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 6px;
}
.ov-item__meta span {
  font-size: 12px;
  color: #777;
}
.ov-item__meta span i {
  margin-right: 3px;
  color: #aaa;
}
.ov-item__pricing {
  display: flex;
  gap: 20px;
  flex-shrink: 0;
  text-align: center;
}
.ov-item__price-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.ov-item__price-label {
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  font-family: "Museo-regular";
}
.ov-item__price-value {
  font-size: 14px;
  color: #6d6e71;
  font-family: "Museo-regular";
}
.ov-item__total {
  font-size: 15px;
  font-family: "Museo-700";
  color: rgb(105, 190, 40);
}

/* ── Address cards ── */
.ov-addresses {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}
@media (max-width: 640px) {
  .ov-addresses {
    grid-template-columns: 1fr;
  }
}

.ov-address-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 18px 20px;
}
.ov-address-card__title {
  font-family: "Museo-regular";
  font-size: 14px;
  color: #6d6e71;
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ov-address-card__title i {
  color: rgb(105, 190, 40);
}
.ov-address-card__name {
  font-family: "Museo-300";
  font-size: 13px;
  color: #777;
  margin-left: auto;
}
.ov-address-card__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.ov-address-card__list li {
  font-size: 13px;
  color: #555;
  line-height: 1.7;
}
.ov-address-card__list li i {
  color: #aaa;
  margin-right: 4px;
}

/* ── Order summary sidebar ── */
.ov-summary {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: 20px;
}
.ov-summary__header {
  background: #6d6e71;
  color: #fff;
  padding: 14px 20px;
}
.ov-summary__header h3 {
  margin: 0;
  font-family: "Museo-regular";
  font-size: 15px;
}
.ov-summary__header h3 i {
  margin-right: 6px;
  opacity: 0.7;
}
.ov-summary__body {
  padding: 18px 20px;
}
.ov-summary__item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}
.ov-summary__item-info {
  flex: 1;
  min-width: 0;
}
.ov-summary__item-name {
  display: block;
  font-size: 13px;
  color: #6d6e71;
  font-family: "Museo-regular";
}
.ov-summary__item-qty {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}
.ov-summary__item-price {
  font-size: 13px;
  font-family: "Museo-regular";
  color: #6d6e71;
  white-space: nowrap;
}
.ov-summary__divider {
  height: 1px;
  background: #eee;
  margin: 14px 0;
}
.ov-summary__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: 13px;
  color: #555;
  margin-bottom: 10px;
}
.ov-summary__row--bold {
  font-family: "Museo-regular";
  color: #6d6e71;
}
.ov-summary__row--address {
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;
}
.ov-summary__row--address > span:first-child {
  font-family: "Museo-regular";
  color: #6d6e71;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.ov-summary__row--total {
  font-size: 16px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: 0;
}
.ov-summary__amount {
  font-family: "Museo-regular";
  white-space: nowrap;
}
.ov-summary__amount--total {
  color: rgb(105, 190, 40);
  font-family: "Museo-700";
  font-size: 18px;
}
.ov-summary__address-text {
  font-size: 13px;
  color: #777;
  line-height: 1.5;
  display: block;
}
.ov-summary__address-text b {
  color: #6d6e71;
  font-family: "Museo-regular";
}
.ov-summary__address-text--paypal {
  color: #003087;
}
.ov-summary__or {
  text-align: center;
  color: #aaa;
  font-size: 13px;
  margin: 10px 0;
}
.ov-summary__footer {
  padding: 0 20px 20px;
}

/* ── CVC verification ── */
.ov-cvc {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}
.ov-cvc__title {
  font-family: "Museo-regular";
  font-size: 14px;
  color: #6d6e71;
  margin: 0 0 6px;
}
.ov-cvc__text {
  font-size: 13px;
  color: #777;
  margin: 0 0 10px;
}
.ov-cvc__stripe #cvc-element {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 10px;
  max-width: 80px;
}

#stripe_error {
  color: #e74c3c;
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
}

/* ── Buttons ── */
.ov-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-family: "Museo-regular";
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  border: none;
}
.ov-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.ov-btn--primary:hover {
  background: #569c21;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.ov-btn--full {
  width: 100%;
  text-align: center;
}
.ov-btn--disabled {
  opacity: 0.6;
  pointer-events: none;
}
.ov-btn--link {
  background: none;
  color: rgb(105, 190, 40);
  padding: 8px 0;
  width: 100%;
  justify-content: center;
  font-size: 13px;
}
.ov-btn--link:hover {
  text-decoration: underline;
}

/* ── Loader ── */
.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100%;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/* ── Responsive ── */
@media (max-width: 640px) {
  .ov-page {
    padding: 16px;
  }
  .ov-item {
    flex-wrap: wrap;
  }
  .ov-item__pricing {
    width: 100%;
    justify-content: flex-end;
    margin-top: 8px;
  }
  .ov-summary__row--address {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/store/order-verify/order-verify.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgIhB;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA9YA;;mDAAA;AAIA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;AAgZF;;AA7YA,qBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cCuBmB;EDtBnB,mBAAA;EACA,eAAA;AAgZF;AA9YE;EACE,wBCCY;EDAZ,qBAAA;AAgZJ;AA/YI;EAAU,0BAAA;AAkZd;AA/YE;EACE,WAAA;AAiZJ;AA9YE;EACE,WAAA;EACA,4BC7BO;AD6aX;AA7YE;EACE,iBAAA;EACA,wBCfY;EDgBZ,qBAAA;EACA,eAAA;AA+YJ;AA9YI;EAAU,0BAAA;AAiZd;;AA7YA,iBAAA;AACA;EACE,mBAAA;AAgZF;AA9YE;EACE,wBC7CO;ED8CP,eAAA;EACA,cCZiB;EDajB,SAAA;AAgZJ;AA9YI;EACE,wBCjCU;EDkCV,iBAAA;AAgZN;;AA3YA,4BAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AA8YF;AA5YE;EANF;IAOI,0BAAA;EA+YF;AACF;AA7YE;EACE,YAAA;AA+YJ;AA3YI;EADF;IAEI,SAAA;EA8YJ;AACF;;AA1YA,yBAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA6YF;AA3YE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AA6YJ;AA1YE;EACE,4BClGO;EDmGP,eAAA;EACA,cChEiB;EDiEjB,SAAA;AA4YJ;AAzYE;EACE,6BCtFY;EDuFZ,WAAA;EACA,eAAA;EACA,4BC5GO;ED6GP,gBAAA;EACA,mBAAA;AA2YJ;;AAvYA,wBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AA0YF;AAxYE;EACE,mBAAA;AA0YJ;AAvYE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAyYJ;AAvYI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAyYN;AAtYI;EACE,mBAAA;AAwYN;AAvYM;EACE,eAAA;EACA,wBChIQ;ADygBhB;AApYE;EACE,OAAA;EACA,YAAA;AAsYJ;AAnYE;EACE,4BC9JO;ED+JP,eAAA;EACA,cC5HiB;ED6HjB,eAAA;EACA,eAAA;EACA,qBAAA;AAqYJ;AAnYI;EACE,wBCnJU;ADwhBhB;AAlYI;EACE,eAAA;AAoYN;AAhYE;EACE,qBAAA;EACA,eAAA;EACA,4BCjLO;EDkLP,mBAAA;EACA,wBChKY;EDiKZ,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAkYJ;AA/XE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAiYJ;AA/XI;EACE,eAAA;EACA,WAAA;AAiYN;AA/XM;EACE,iBAAA;EACA,WAAA;AAiYR;AA5XE;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AA8XJ;AA3XE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AA6XJ;AA1XE;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,4BC7NO;ADylBX;AAzXE;EACE,eAAA;EACA,cC9LiB;ED+LjB,4BCnOO;AD8lBX;AAxXE;EACE,eAAA;EACA,wBCvOO;EDwOP,wBCtNY;ADglBhB;;AAtXA,wBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAyXF;AAvXE;EANF;IAOI,0BAAA;EA0XF;AACF;;AAvXA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA0XF;AAxXE;EACE,4BChQO;EDiQP,eAAA;EACA,cC9NiB;ED+NjB,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA0XJ;AAxXI;EACE,wBCtPU;ADgnBhB;AAtXE;EACE,wBChRO;EDiRP,eAAA;EACA,WAAA;EACA,iBAAA;AAwXJ;AArXE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAuXJ;AArXI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAuXN;AArXM;EACE,WAAA;EACA,iBAAA;AAuXR;;AAjXA,gCAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAoXF;AAlXE;EACE,mBC5QiB;ED6QjB,WAAA;EACA,kBAAA;AAoXJ;AAlXI;EACE,SAAA;EACA,4BCtTK;EDuTL,eAAA;AAoXN;AAlXM;EACE,iBAAA;EACA,YAAA;AAoXR;AA/WE;EACE,kBAAA;AAiXJ;AA9WE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAgXJ;AA7WE;EACE,OAAA;EACA,YAAA;AA+WJ;AA5WE;EACE,cAAA;EACA,eAAA;EACA,cChTiB;EDiTjB,4BCrVO;ADmsBX;AA3WE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AA6WJ;AA1WE;EACE,eAAA;EACA,4BCjWO;EDkWP,cC9TiB;ED+TjB,mBAAA;AA4WJ;AAzWE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AA2WJ;AAxWE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA0WJ;AAxWI;EACE,4BCtXK;EDuXL,cCnVe;AD6rBrB;AAvWI;EACE,sBAAA;EACA,QAAA;EACA,mBAAA;AAyWN;AAvWM;EACE,4BChYG;EDiYH,cC7Va;ED8Vb,eAAA;EACA,yBAAA;EACA,qBAAA;AAyWR;AArWI;EACE,eAAA;EACA,wBCzYK;ED0YL,cCvWe;EDwWf,gBAAA;AAuWN;AAnWE;EACE,4BCjZO;EDkZP,mBAAA;AAqWJ;AAnWI;EACE,wBClYU;EDmYV,wBCrZK;EDsZL,eAAA;AAqWN;AAjWE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAmWJ;AAjWI;EACE,cC9Xe;ED+Xf,4BCnaK;ADswBX;AAhWI;EACE,cAAA;AAkWN;AA9VE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAgWJ;AA7VE;EACE,oBAAA;AA+VJ;;AA3VA,2BAAA;AACA;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AA8VF;AA5VE;EACE,4BC9bO;ED+bP,eAAA;EACA,cC5ZiB;ED6ZjB,eAAA;AA8VJ;AA3VE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AA6VJ;AAzVI;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA2VN;;AAtVA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAyVF;;AAtVA,kBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BCneS;EDoeT,eAAA;EACA,qBAAA;EACA,eAAA;EACA,4CAAA;EACA,YAAA;AAyVF;AAvVE;EACE,6BCxdY;EDydZ,WAAA;AAyVJ;AAxVI;EACE,mBAAA;EACA,yCAAA;AA0VN;AAtVE;EACE,WAAA;EACA,kBAAA;AAwVJ;AArVE;EACE,YAAA;EACA,oBAAA;AAuVJ;AApVE;EACE,gBAAA;EACA,wBC5eY;ED6eZ,cAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AAsVJ;AApVI;EACE,0BAAA;AAsVN;;AAjVA,iBAAA;AACA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAoVF;;AAjVA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAoVF;;AAjVA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAoVF;;AAjVA;EACE,mCAAA;EACA,UAAA;AAoVF;;AAlVA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAqVF;;AAnVA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAsVF;;AApVA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAuVF;;AApVA;EACE;IAAK,UAAA;EAwVL;EAvVA;IAAM,UAAA;EA0VN;EAzVA;IAAO,UAAA;EA4VP;AACF;AA1VA,qBAAA;AACA;EACE;IACE,aAAA;EA4VF;EAzVA;IACE,eAAA;EA2VF;EAzVE;IACE,WAAA;IACA,yBAAA;IACA,eAAA;EA2VJ;EAvVA;IACE,eAAA;EAyVF;AACF","sourcesContent":["@import './../../../../assets/styles/variables';\n\n/* ──────────────────────────────────────────────\n   Order Verify Page — ov-* BEM\n   ────────────────────────────────────────────── */\n\n.ov-page {\n  padding: 20px 24px 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* ── Breadcrumb ── */\n.ov-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: $color-neutral-dark;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n\n  &__link {\n    color: $develop-color;\n    text-decoration: none;\n    &:hover { text-decoration: underline; }\n  }\n\n  &__sep {\n    color: #bbb;\n  }\n\n  &__current {\n    color: #555;\n    font-family: $muso-500;\n  }\n\n  &__shop-link {\n    margin-left: auto;\n    color: $develop-color;\n    text-decoration: none;\n    font-size: 13px;\n    &:hover { text-decoration: underline; }\n  }\n}\n\n/* ── Header ── */\n.ov-header {\n  margin-bottom: 24px;\n\n  &__title {\n    font-family: $muso-700;\n    font-size: 22px;\n    color: $color-neutral-dark;\n    margin: 0;\n\n    i {\n      color: $develop-color;\n      margin-right: 6px;\n    }\n  }\n}\n\n/* ── Two-column layout ── */\n.ov-layout {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 28px;\n  align-items: start;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__main {\n    min-width: 0;\n  }\n\n  &__sidebar {\n    @media (max-width: 900px) {\n      order: -1;\n    }\n  }\n}\n\n/* ── Card container ── */\n.ov-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  margin-bottom: 24px;\n  overflow: hidden;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    border-bottom: 1px solid #eee;\n    background: #fafafa;\n  }\n\n  &__title {\n    font-family: $muso-500;\n    font-size: 15px;\n    color: $color-neutral-dark;\n    margin: 0;\n  }\n\n  &__badge {\n    background: $develop-color;\n    color: #fff;\n    font-size: 12px;\n    font-family: $muso-500;\n    padding: 2px 9px;\n    border-radius: 12px;\n  }\n}\n\n/* ── Cart item row ── */\n.ov-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &__image {\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #f5f5f5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &--gift {\n      background: lighten($develop-color, 42%);\n      i {\n        font-size: 26px;\n        color: $develop-color;\n      }\n    }\n  }\n\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__name {\n    font-family: $muso-500;\n    font-size: 14px;\n    color: $color-neutral-dark;\n    margin: 0 0 4px;\n    cursor: pointer;\n    text-decoration: none;\n\n    &:hover {\n      color: $develop-color;\n    }\n\n    &--comp {\n      cursor: pointer;\n    }\n  }\n\n  &__comp-badge {\n    display: inline-block;\n    font-size: 11px;\n    font-family: $muso-500;\n    background: lighten($develop-color, 42%);\n    color: $develop-color;\n    padding: 1px 8px;\n    border-radius: 10px;\n    margin-left: 6px;\n    vertical-align: middle;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 14px;\n    margin-top: 6px;\n\n    span {\n      font-size: 12px;\n      color: #777;\n\n      i {\n        margin-right: 3px;\n        color: #aaa;\n      }\n    }\n  }\n\n  &__pricing {\n    display: flex;\n    gap: 20px;\n    flex-shrink: 0;\n    text-align: center;\n  }\n\n  &__price-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n  }\n\n  &__price-label {\n    font-size: 11px;\n    color: #999;\n    text-transform: uppercase;\n    font-family: $muso-500;\n  }\n\n  &__price-value {\n    font-size: 14px;\n    color: $color-neutral-dark;\n    font-family: $muso-500;\n  }\n\n  &__total {\n    font-size: 15px;\n    font-family: $muso-700;\n    color: $develop-color;\n  }\n}\n\n/* ── Address cards ── */\n.ov-addresses {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ov-address-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 18px 20px;\n\n  &__title {\n    font-family: $muso-500;\n    font-size: 14px;\n    color: $color-neutral-dark;\n    margin: 0 0 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    i {\n      color: $develop-color;\n    }\n  }\n\n  &__name {\n    font-family: $muso-300;\n    font-size: 13px;\n    color: #777;\n    margin-left: auto;\n  }\n\n  &__list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      font-size: 13px;\n      color: #555;\n      line-height: 1.7;\n\n      i {\n        color: #aaa;\n        margin-right: 4px;\n      }\n    }\n  }\n}\n\n/* ── Order summary sidebar ── */\n.ov-summary {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: 20px;\n\n  &__header {\n    background: $color-neutral-dark;\n    color: #fff;\n    padding: 14px 20px;\n\n    h3 {\n      margin: 0;\n      font-family: $muso-500;\n      font-size: 15px;\n\n      i {\n        margin-right: 6px;\n        opacity: 0.7;\n      }\n    }\n  }\n\n  &__body {\n    padding: 18px 20px;\n  }\n\n  &__item {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 12px;\n  }\n\n  &__item-info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__item-name {\n    display: block;\n    font-size: 13px;\n    color: $color-neutral-dark;\n    font-family: $muso-500;\n  }\n\n  &__item-qty {\n    display: block;\n    font-size: 12px;\n    color: #999;\n    margin-top: 2px;\n  }\n\n  &__item-price {\n    font-size: 13px;\n    font-family: $muso-500;\n    color: $color-neutral-dark;\n    white-space: nowrap;\n  }\n\n  &__divider {\n    height: 1px;\n    background: #eee;\n    margin: 14px 0;\n  }\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    font-size: 13px;\n    color: #555;\n    margin-bottom: 10px;\n\n    &--bold {\n      font-family: $muso-500;\n      color: $color-neutral-dark;\n    }\n\n    &--address {\n      flex-direction: column;\n      gap: 4px;\n      margin-bottom: 14px;\n\n      > span:first-child {\n        font-family: $muso-500;\n        color: $color-neutral-dark;\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.3px;\n      }\n    }\n\n    &--total {\n      font-size: 16px;\n      font-family: $muso-700;\n      color: $color-neutral-dark;\n      margin-bottom: 0;\n    }\n  }\n\n  &__amount {\n    font-family: $muso-500;\n    white-space: nowrap;\n\n    &--total {\n      color: $develop-color;\n      font-family: $muso-700;\n      font-size: 18px;\n    }\n  }\n\n  &__address-text {\n    font-size: 13px;\n    color: #777;\n    line-height: 1.5;\n    display: block;\n\n    b {\n      color: $color-neutral-dark;\n      font-family: $muso-500;\n    }\n\n    &--paypal {\n      color: #003087;\n    }\n  }\n\n  &__or {\n    text-align: center;\n    color: #aaa;\n    font-size: 13px;\n    margin: 10px 0;\n  }\n\n  &__footer {\n    padding: 0 20px 20px;\n  }\n}\n\n/* ── CVC verification ── */\n.ov-cvc {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #eee;\n\n  &__title {\n    font-family: $muso-500;\n    font-size: 14px;\n    color: $color-neutral-dark;\n    margin: 0 0 6px;\n  }\n\n  &__text {\n    font-size: 13px;\n    color: #777;\n    margin: 0 0 10px;\n  }\n\n  &__stripe {\n    #cvc-element {\n      border: 1px solid #ddd;\n      border-radius: 6px;\n      padding: 8px 10px;\n      max-width: 80px;\n    }\n  }\n}\n\n#stripe_error {\n  color: #e74c3c;\n  margin-top: 8px;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* ── Buttons ── */\n.ov-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-family: $muso-500;\n  font-size: 14px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.2s, box-shadow 0.2s;\n  border: none;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    &:hover {\n      background: darken($develop-color, 8%);\n      box-shadow: 0 2px 8px rgba(0,0,0,0.12);\n    }\n  }\n\n  &--full {\n    width: 100%;\n    text-align: center;\n  }\n\n  &--disabled {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n  &--link {\n    background: none;\n    color: $develop-color;\n    padding: 8px 0;\n    width: 100%;\n    justify-content: center;\n    font-size: 13px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n/* ── Loader ── */\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, 0.9);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, 0.9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: 0.5s;\n  opacity: 0;\n}\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 640px) {\n  .ov-page {\n    padding: 16px;\n  }\n\n  .ov-item {\n    flex-wrap: wrap;\n\n    &__pricing {\n      width: 100%;\n      justify-content: flex-end;\n      margin-top: 8px;\n    }\n  }\n\n  .ov-summary__row--address {\n    font-size: 12px;\n  }\n}\n","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
